export default __webpack_public_path__ + "static/media/avatar.33db01c5.jpeg";